import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfBrand } from '../../database/index';

import { useAuth } from "src/contexts/auth";
import api from '../../services/api';

export const useFormCreateBrands = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [brandResponse, setBrandResponse] = useState<AxiosResponse | null>(null);
  const [brandEditedResponse, setBrandEditedResponse] = useState<AxiosResponse | null>(null);
  const history = useHistory();

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO: Yup.string().required('* Campo obrigatório')
  });

  const saveBrand = async (brand: ModelOfBrand) => {
    setLoading(true);

    const newBrand: ModelOfBrand = {
      ...brand,
      ORGAO: userAgencyId
    }

    if (!!brandResponse) {
      api.put(`brands/${brandResponse.data.ID}`, newBrand)
        .then((response) => {
          formik.resetForm();
          setBrandEditedResponse(response);
          setBrandResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A marca foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      api.post('brands', newBrand)
        .then((response) => {
          if (window.location.href === '/brandForm') history.push('/listBrands')
          setLoading(false);
          setBrandResponse(response)
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  }

  const formik = useFormik<ModelOfBrand>({
    initialValues: {
      ORGAO: '',
      DESCRICAO: '',
    },
    onSubmit: async values => await saveBrand(values),
    validationSchema
  });

  return {
    getBrandFormController: {
      formik,
      loading,
      toast,
      brandResponse,
      brandEditedResponse
    },
    handleBrandFormController: {
      setBrandResponse,
      setBrandEditedResponse
    }
  };
};
